import * as React from 'react';
import CircleIOutlined from './circle-i-outlined';
import CircleIFilled from './circle-i-filled';
import type { IconCombinedProps } from './types';
const CircleICombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <CircleIFilled ref={ref} {...rest} />;
  }
  return <CircleIOutlined ref={ref} {...rest} />;
});
export default CircleICombined;